import React, {useEffect, useMemo} from 'react';
import styled from 'styled-components';
import {wh, fontSize} from '../../mixins';
import {useSelector, useDispatch} from 'react-redux';
import {selectPlan, setPlan, setUpsellPlan} from './paywallSlice';
import {selectOfferType} from '../onboarding/onboardingSlice';


const StyledLi = styled.li`
  background: ${props => props.active ? '#FBA253' : 'transparent'};
  border-radius: 11px;
  width: 33%;
  max-width: 108px;
  min-height: ${props => (!props.cropBorder && props.active) ? '184px' : '208px'};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
   
  &>span {
    text-transform: uppercase;
    text-align: center;
    letter-spacing: -0.2px;
    font-weight: 800;
    color: #FFFFFF;
    mix-blend-mode: normal;
    ${fontSize(12)};
    line-height: 26px;
  }
`;

const StyledOffer = styled.button`
  ${wh('96%', '180px')};
  margin: 0 auto 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  color: #323232;
  background: #FFFFFF;
  box-shadow: 0 4px 20px rgba(0,0,0,.25);
  border-radius: 10px;
  padding: 0 8px;
  text-align: center;
  position: relative;
  z-index: 90;
  border: none;

  &:focus {
    outline: none;
  }
  
  b {
      ${fontSize(34)};
      line-height: 40px;
      font-weight: 800;
      margin-bottom: 6px;
  }
`;

const RibbonWrapper = styled.div`
  width: 115px;
  height: 88px;
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  
  div {
    transform: rotate(45deg);
    position: relative;
    padding: 3px 0;
    top: 15px;
    right: -30px;
    width: 120px;
    background: #00A08B;
    ${fontSize(8)};
    line-height: 18px;
    color: #FFFFFF;
    mix-blend-mode: normal;
    text-align: center;
    letter-spacing: 1px;
  }
`;

const StyledList = styled.ul`
  width: 100%;
  max-width: 345px;
  display: flex;
  flex-direction: row${({isDiscountb}) => isDiscountb ? '-reverse' : ''};
  justify-content: space-between;
  padding: 0;
  margin: 0 0 16px;
  list-style: none;
  align-items: flex-end;
`;

const StyledPrice = styled.p`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 13px 0 20px;
  padding-top: 8px;
  border-top: 1px solid ${({empty}) => empty ? 'transparent' : 'rgba(132,132,132,.4)'};
  width: 100%;

  span {
      color: #FBA253;
      ${fontSize(16)};
      line-height: 20px;
      min-height: 20px;
      mix-blend-mode: normal;
      opacity: 0.9;
      font-weight: 300;
      letter-spacing: unset;
      
      &:last-child {
        ${fontSize(12)};
        line-height: 16px;
        min-height: 16px;
      }
  }
`;

const StyledPeriod = styled.span`
    ${fontSize(14)};
    line-height: 17px;
    ${({bigTitle}) => bigTitle && `
        white-space: nowrap;
        font-weight: 600;
    `}
`;

const StyledNote = styled.p`
   margin: 0;
   min-height: 32px;
   ${fontSize(12)};
   line-height: 16px;
   color: #FBA253;
   mix-blend-mode: normal;
   opacity: 0.9;
   font-weight: 400;
   letter-spacing: unset;
`;


const DefaultPlans = () => {
    const plan = useSelector(selectPlan);
    const dispatch = useDispatch();
    const offerType = useSelector(selectOfferType);

    const basicPaywall = [
        {
            id: 'gz-6-month-panther',
            title: '6',
            period: 'months',
            price: '$2.99',
            bestValue: true,
            label: 'SAVE 76%',
            week: 'per week'

        },
        {
            id: 'gz-3-month-fox',
            title: '3',
            period: 'months',
            price: '$4.99',
            label: 'SAVE 52%',
            week: 'per week'

        },
        {
            id: 'gz-1-month-tiger',
            title: '1',
            period: 'month',
            price: '$9.99',
            week: 'per week'

        },
    ];

    const discountPaywall = [
        {
            id: 'gz-3-month-garlic',
            title: '3',
            period: 'months',
            price: '$2.99',
            bestValue: true,
            label: 'SAVE 76%',
            week: 'per week'

        },
        {
            id: 'gz-1-month-tomato',
            title: '1',
            period: 'month',
            price: '$4.99',
            label: 'SAVE 52%',
            week: 'per week'

        },
        {
            id: 'gz-1-month-intro-franko',
            title: '1',
            period: 'week',
            price: '$9.99',
            week: 'per week*'
        },
    ];

    const upPaywall = [
        {
            id: 'gz-6-month-panther',
            title: '6',
            period: 'months',
            price: '$2.99',
            bestValue: true,
            label: 'SAVE 76%',
            week: 'per week',
            upsellPlan: 'gz-6month-upsell-999',
        },
        {
            id: 'gz-3-month-fox',
            title: '3',
            period: 'months',
            price: '$4.99',
            label: 'SAVE 52%',
            week: 'per week',
            upsellPlan: 'gz-3month-upsell-999',
        },
        {
            id: 'gz-1-month-tiger',
            title: '1',
            period: 'month',
            price: '$9.99',
            week: 'per week',
            upsellPlan: 'gz-monthly-upsell-999',
        },
    ];

    const OFFERS = useMemo(() => {
        return {
            fullPrice: basicPaywall,
            demo: basicPaywall,
            optionsy: basicPaywall,
            optionsx: basicPaywall,
            discount: discountPaywall,
            optionsc: discountPaywall,
            family: [
                {
                    id: 'gz-3-month-garlic',
                    title: '3',
                    period: 'months',
                    price: '$2.99',
                    bestValue: true,
                    label: 'SAVE 76%',
                    week: 'per week'

                },
                {
                    id: 'gz-1-month-tomato',
                    title: '1',
                    period: 'month',
                    price: '$4.99',
                    label: 'SAVE 52%',
                    week: 'per week'

                },
                {
                    id: 'gz-1-week-cucumber',
                    title: '1',
                    period: 'week',
                    price: '$9.99',
                    week: 'per week'

                },
            ],
            discountb: [
                {
                    id: 'gz-monthly-free3d-2999',
                    title: '3',
                    period: 'DAYS FREE*',
                    label: 'popular',
                },
                {
                    id: 'gz-1-month-tomato',
                    title: '1',
                    period: 'month',
                    price: '$4.99',
                    week: 'per week',
                },
                {
                    id: 'gz-3-months-red-banana',
                    title: '3',
                    period: 'months',
                    price: '$3.33',
                    bestValue: true,
                    week: 'per week',
                },
            ],
            up: upPaywall,
            family_fullPrice: discountPaywall,
        };
    },[]);

    const currentPlans = useMemo(() => OFFERS[offerType], [offerType, OFFERS]);

    useEffect(() => {
        dispatch(setPlan(currentPlans[0].id));
        dispatch(setUpsellPlan(currentPlans[0].upsellPlan || ''));
    }, [dispatch]);

    const onPlanClick = (id, upsellPlan) => {
        dispatch(setPlan(id));
        upsellPlan !== '' && dispatch(setUpsellPlan(upsellPlan));
    };

    const renderOffer = (i, index) => {
        const {
            id,
            label,
            bestValue,
            title,
            period,
            price,
            week,
            upsellPlan = '',
        } = i;
        const isActive = plan === i.id;

        return <StyledLi active={isActive} cropBorder={!!label} key={id}>
            <span>{isActive && label}</span>

            <StyledOffer key={id} onClick={() => onPlanClick(id, upsellPlan)} selected={isActive} id={'plan-button-' + (index + 1)}>
                {bestValue && (
                    <RibbonWrapper>
                        <div>BEST VALUE</div>
                    </RibbonWrapper>
                )}
                <b>{title}</b>
                <StyledPeriod bigTitle={id === 'gz-monthly-free3d-2999'}>{period}</StyledPeriod>
                <StyledPrice>
                    <span>{price}</span>
                    <span>{week}</span>
                </StyledPrice>
            </StyledOffer>
        </StyledLi>;
    };

    const note = (() => {
        if ((offerType === 'discount' || offerType === 'optionsc') && plan === 'gz-1-month-intro-franko') {
            return <StyledNote>*Trial offer, billed at $19.96/mo after</StyledNote>;
        }
        if (offerType === 'discountb' && plan === 'gz-monthly-free3d-2999') {
            return <StyledNote>Trial offer, billed at $29.99/month</StyledNote>;
        }
        return null;
    })();


    return (
        <>
            <StyledList isDiscountb={offerType === 'discountb'}>
                {currentPlans.map(renderOffer)}
            </StyledList>
            {note}
        </>
    );
};

export default DefaultPlans;
